import { blackColors, warningColor, grayColor } from 'assets/jss/material-dashboard-pro-react';

const priceTagStyles = (theme) => ({
	mainWrapper: {
		display: 'inline-flex',
		flexDirection: 'column',
	},
	discountPriceWrapper: {
		display: 'inline-flex',
		flexDirection: 'row',
		width: '100%',
	},
	discountStrikethroughWrapper: {
		textDecoration: 'line-through',
		color: warningColor[0],
	},
	miniDiscountPrice: {
		color: warningColor[0],
		textAlign: 'right',
		margin: '2px 3px 4px 0',
	},
	priceTagWrapper: {
		display: 'inline-flex',
		flexDirection: 'row',
		alignSelf: 'unset',
	},
	smallPrice: {
		fontFamily: theme.fontFamily.alvar.bold,
		color: grayColor[11],
		fontSize: '24px',
	},
	additionalInfoWrapper: {
		paddingLeft: '2px',
		color: grayColor[11],
		fontFamily: theme.fontFamily.alvar.bold,
		fontSize: '10px',
		marginTop: '-10px',
	},
	smallCurrencyWrapper: {
		padding: '0',
		paddingRight: '0',
		color: blackColors[0],
	},
});

export default priceTagStyles;
